<authority-labs-check-case
  [inspection]="planningDetails"
  [hideConclusion]="true"
  [printPreview]="printPreview"
  [readonly]="readonly"
  (dataChange)="onChange()"
>
  <table
    mat-table
    class="mat-elevation-z4 boundary"
    cdkDropList
    [dataSource]="planningDetails.plans"
    [cdkDropListData]="planningDetails.plans"
    [cdkDropListDisabled]="readonly || printPreview"
    (cdkDropListDropped)="drop($event)"
  >
    <ng-container matColumnDef="drag">
      <th mat-header-cell *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let element"
        cdkDrag
        cdkDragRootElement="tr"
        cdkDragLockAxis="y"
        cdkDragBoundary=".boundary"
        [cdkDragData]="element"
      >
        <div cdkDragHandle class="drag-handle">
          <authority-labs-drag-icon></authority-labs-drag-icon>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>שם המסמך</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <textarea
            matInput
            class="text"
            cdkTextareaAutosize
            name="name"
            [(ngModel)]="element.name"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          ></textarea>
          <div matSuffix class="note-btns" *ngIf="!(readonly || printPreview)">
            <button
              mat-icon-button
              aria-label="notes-bank"
              color="primary"
              *ngIf="!(readonly || printPreview)"
              (click)="showNotesBank($event, element)"
            >
              <mat-icon>assignment</mat-icon>
            </button>
          </div>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="identificationCode">
      <th mat-header-cell *matHeaderCellDef>קוד זיהוי</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <textarea
            matInput
            class="text"
            cdkTextareaAutosize
            name="identificationCode"
            [(ngModel)]="element.identificationCode"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          ></textarea>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="creator">
      <th mat-header-cell *matHeaderCellDef>יוצר</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <input
            matInput
            class="text"
            cdkTextareaAutosize
            name="edition"
            [(ngModel)]="element.creator"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>תאריך</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field *ngIf="!(readonly || printPreview)">
          <input
            matInput
            class="text"
            name="date"
            [matDatepicker]="picker"
            [(ngModel)]="element.date"
            (dateInput)="onChange()"
            (dateChange)="onChange()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field *ngIf="readonly || printPreview">
          <input
            matInput
            class="text"
            name="date"
            [ngModel]="element.date | date : 'shortDate'"
            readonly
          />
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="conclusion">
      <th mat-header-cell *matHeaderCellDef>מסקנה</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <mat-select
            [class.warn]="!element.isPassed"
            name="conclusion"
            [readonly]="readonly || printPreview"
            [(ngModel)]="element.isPassed"
            (selectionChange)="onChange()"
          >
            <mat-option [value]="null"> --- </mat-option>
            <mat-option [value]="true"> מתאים </mat-option>
            <mat-option [value]="false" style="color: red">
              לא מתאים
            </mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>הערות</th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field>
          <textarea
            matInput
            class="text"
            cdkTextareaAutosize
            name="notes"
            [(ngModel)]="element.notes"
            [readonly]="readonly"
            (input)="onChange()"
          ></textarea>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef>קובץ</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button (click)="viewFile(element.fileId)">
          {{ element.fileName }}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button mat-icon-button [matMenuTriggerFor]="mainmenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #mainmenu="matMenu">
          <button mat-menu-item (click)="addPlan()">הוסף תוכנית</button>
          <button
            mat-menu-item
            (click)="addPlansByDocs()"
            *ngIf="orderId && orderDirectory"
          >
            הוסף תוכניות מקבצים
          </button>
        </mat-menu>
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            (click)="attachDoc(element)"
            *ngIf="orderId && orderDirectory"
          >
            צרף קובץ מרשימה
          </button>
          <button
            mat-menu-item
            (click)="selectFile(element)"
            *ngIf="orderId && orderDirectory"
          >
            <nz-upload
              [(nzFileList)]="fileList"
              [nzBeforeUpload]="uploadDirectory.beforeUpload"
            >
              העלאת קובץ חדש
            </nz-upload>
          </button>
          <button mat-menu-item (click)="remove(element)">הסר</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</authority-labs-check-case>
